<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      item-key="MessageId"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("DayName"),
          value: "DayName",
        },
        {
          text: this.$t("DDATE"),
          value: "DDate",
        },
        {
          text: this.$t("EntryTime"),
          value: "ioBT",
        },
        {
          text: this.$t("ExitTime"),
          value: "ioET",
        },
        {
          text: this.$t("DurationTime"),
          value: "Duration4",
        },
        {
          text: this.$t("Title"),
          value: "Title1",
        },
        {
          text: this.$t("Duration"),
          value: "Duration1",
        },
        {
          text: this.$t("Title"),
          value: "Title2",
        },
        {
          text: this.$t("Duration"),
          value: "Duration2",
        },
        {
          text: this.$t("Title"),
          value: "Title3",
        },
        {
          text: this.$t("Duration"),
          value: "Duration3",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
</style>